<div hsg-modal-header *ngIf="data.title">
	<h3>{{ data.title }}</h3>
	<a class="modal-close-icon cancel" hsgModalClose>
		<span class="icon-cross"></span>
	</a>
</div>
<div hsg-modal-body [ngClass]="{ 'loading': loading }">
    <table *ngIf="importedRows && importedRows.length > 0">
        <thead>
            <tr>
                <th>Facility Name</th>
                <th>Cost Center ID</th>
                <th>Cost Center Name</th>
                <th>Employee ID</th>
                <th>Employee First Name</th>
                <th>Employee Last Name</th>
                <th>Clock In Date Time</th>
                <th>Clock In Date Time Rounded</th>
                <th>Clock Out Date Time</th>
                <th>Clock Out Date Time Rounded</th>
                <th>Employee Job Title</th>
                <th>Time Pay Code</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let importedRow of importedRows">
                <td>{{ importedRow.facilityName }}</td>
                <td>{{ importedRow.hisCostCenterId }}</td>
                <td>{{ importedRow.costCenterName }}</td>
                <td>{{ importedRow.employeeId }}</td>
                <td>{{ importedRow.employeeFirstName }}</td>
                <td>{{ importedRow.employeeLastName }}</td>
                <td>{{ importedRow.clockInDateTime | date:'short' }}</td>
                <td>{{ importedRow.clockInDateTimeRounded | date:'short' }}</td>
                <td>{{ importedRow.clockOutDateTime | date:'short' }}</td>
                <td>{{ importedRow.clockOutDateTimeRounded | date:'short' }}</td>
                <td>{{ importedRow.employeeJobTitle }}</td>
                <td>{{ importedRow.timePayCode }}</td>
            </tr>
        </tbody>
    </table>
    <div *ngIf="!loading && (!importedRows || importedRows.length == 0)">There is no imported data to display for this shift block.</div>
</div>
<div hsg-modal-footer>
	<button class="cancel" [hsgModalClose]="false" *ngIf="data.rejectText">
		{{ data.rejectText }}
	</button>
</div>